import { createFileRoute } from '@tanstack/react-router';

import { ComingSoon } from '~/components/ComingSoon';
import { DEFAULT_LOCALE } from '~/utils/i18n';

const ChornaPage = () => {
  return <ComingSoon title="Chorna" subtitle="Our Products" />;
};

export const Route = createFileRoute('/products/chorna')({
  beforeLoad: ({ context }) => ({
    ...context,
    locale: DEFAULT_LOCALE,
  }),
  component: ChornaPage,
});

